import React  from 'react';
import GatewayBasicInfoComponent from './gateway-basic-info.component';
import GatewayKeyPairInfoComponent from './gateway-key-pair-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
export const GatewayComponent = ({dbas,handleFormChange,selectedGateway,handleInnerFormChange,domainDetails,networks,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<GatewayBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedGateway={selectedGateway}
        domainDetails={domainDetails}
        networks={networks}
        handleFormChange={handleFormChange}
        dbas={dbas}
        />,
    isVisible:true,
    },
    {
        id:2,
        title:'KeyPair Info',
        component:<GatewayKeyPairInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedGateway={selectedGateway}
        />,
    isVisible:true,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
           
        </div>
       </div>
  )
}
export default GatewayComponent;
